import { array, object, string, number } from '@gogame/schemas';

import {
  NAME,
  APPLICATIONS,
  NETWORKS,
  PLATFORMS,
  ATTACH_FILE,
} from './constants';

export const FileBasedAudienceFormValidationSchema = object({
  [NAME]: string().required('Name is required'),
  [APPLICATIONS]: array(number()).required('Applications is required'),
  [NETWORKS]: array(number()).required('Networks is required'),
  [PLATFORMS]: array(number()).required('Platforms is required'),
  [ATTACH_FILE]: string().nullable().required('File is required'),
});
